import type { TaskStatus } from './enums'

export interface ActionLike {
  readonly done: boolean
}

export interface ActionProgress {
  readonly done: number
  readonly total: number
  /** 0–100, arredondado. 0 quando não há ações. */
  readonly pct: number
}

export function actionProgress(actions: readonly ActionLike[]): ActionProgress {
  const total = actions.length
  const done = actions.filter((a) => a.done).length
  return { done, total, pct: total ? Math.round((done / total) * 100) : 0 }
}

/**
 * Status que as ações sugerem — nunca imposto (decisão do Supply).
 *
 * No protótipo as ações recalculavam o status sozinhas, o que tirava do dono
 * a decisão de fechar. Aqui a tela mostra a sugestão e quem tem permissão
 * aceita com um clique. Devolve `null` quando a sugestão é o status atual ou
 * quando não há ações.
 */
export function suggestStatus(current: TaskStatus, progress: ActionProgress): TaskStatus | null {
  if (current === 'cancelada' || progress.total === 0) return null
  let suggestion: TaskStatus
  if (progress.done === progress.total) suggestion = 'realizada'
  else if (progress.done > 0) suggestion = 'em_processo'
  else return null
  return suggestion === current ? null : suggestion
}

/** Percentual entregue de uma tarefa (0–100). */
export function deliveredPct(qtdPrevista: number, qtdEntregue: number): number {
  if (!qtdPrevista) return 0
  return Math.min(100, Math.round((qtdEntregue / qtdPrevista) * 100))
}
